<template>
  <div class="card_offer">
    <img
      class="card_offer__image"
      :src="getImageServer() + items.attributes.url"
      v-if="items.attributes && items.attributes.url"
    >
    <img
      class="card_offer__image"
      src="@/assets/img/img-defecto.svg"
      v-else
    >
    <div class="card_offer__actions">
      <v-layout row wrap fill-height>
        <v-flex xs8>
          <div class="actions_date">
            <img src="@/assets/img/icons/available-icon.svg" />
            <div class="actions_date__text">
              <div>Publicado</div>
              <div class="actions_date__date" v-if="items.attributes.created_at">
                {{ shortDate(items.attributes.created_at) }}
              </div>
              <div class="actions_date__date" v-else>
                {{ today }}
              </div>

            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="card_offer__body">
      <div class="card_offer__body--title">
        {{items.attributes.name | capitalize}}
      </div>

      <div class="card_offer__body--subtitle">
        Descripción
      </div>
      <div
        class="card_offer__body--text"
        v-html="items.attributes.description"
        style="height: 200px"
      ></div>

      <span class="card_offer__body--subtitle">
        Es visible para los usuarios
      </span>
      <p class="card_offer__body--text classes_quantity">
        {{ items.attributes.visible_to_user ? 'Si' : 'No' }}
      </p>

    </div>
  </div>
</template>
<script>
export default {
  props:{
    items: {}
  },
  data(){
    return {
      today: null
    }
  },
  mounted(){
   this.today = new Date().toISOString().slice(0, 10)
  },

}
</script>

<style scoped>
  .card_offer__body--title{
    height: 120px;
    background: #EFF3F7!important;
    border-radius: 10px;
    padding: 10px;
  }
  .card_offer__body--text{
    margin-bottom: 20px;
    background: #EFF3F7 !important;
    border-radius: 10px;
    padding: 10px;
  }
  .classes_quantity{
    width: 40px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/PreviewNew.vue